import React from "react"
import { graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

import Layout from "../../../components/layout"
import SEOComponent from "../../../components/seo"
import H1 from "../../../components/h1"
import BlogSidebar from "../../../components/blogSidebar"

function createMarkup(params) {
  return {__html: params};
};

const EtchingXBlog = (props) => {
  const { title, publishedAt, tags, contentHtml, image, localFile } = props.data.shopifyArticle
  const seoTitle = props.data.shopifyArticle.seo.title
  const seoDescription = props.data.shopifyArticle.seo.description

  return (
    <Layout>
      <SEOComponent
        title={ seoTitle || title }
        description={seoDescription}
      />
        <div className="container p-5">
          <div className="columns">
            <div className="column">
              <H1 header={title} />
              <p>{publishedAt}</p>
              <div className="flex flex-row">
                {tags.map((e, i) => (
                  <span key={i} className="mr-2">{e}</span>
                ))}
              </div>
              <GatsbyImage image={localFile.childImageSharp.gatsbyImageData} alt={image.altText} />
              <div dangerouslySetInnerHTML={createMarkup(contentHtml)} />
            </div>
            <div className="column is-one-quarter">
              <BlogSidebar />
            </div>
          </div>
        </div>
    </Layout>
  )
}

export default EtchingXBlog

export const query = graphql`
  query($id: String) {
    shopifyArticle(id: { eq: $id }) {
      handle
      id
      title
      publishedAt(formatString: "MMMM Do, YYYY")
      blog {
        handle
      }
      seo {
        description
        title
      }
      tags
      contentHtml
      image {
        altText
      }
      localFile {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  }
`